import React, {FC, memo} from "react";
import {CheckboxProps} from "./Checkbox-types";
import {Input, Label, Root} from "./Checkbox-styles";


const dumb = () => {};

const Checkbox: FC<CheckboxProps> = memo((props) => {
    const {id, text, value, isChecked, onClick} = props;

    return (
        <Root>
            <Input
                id={id}
                onChange={dumb}
                value={String(value)}
                type="checkbox"
                checked={isChecked}
            />

            <Label htmlFor={id} onClick={() => onClick(value)}>{text}</Label>
        </Root>
    )
});

export default Checkbox;
